const ProposalStatusConstants = {
    DRAFT: 0,
    INPROGRESS: 1,
    NOGO: 2,
    WON: 3,
    LOST: 4,
    UNKNOWN: 5
}

export default ProposalStatusConstants